//Sustainability Event 2023

const SUSTAINABILITY_23 = {
  agenda: [
    {
      date: "3:00 PM to 3:10 PM",
      topic: "Welcome Note",
      p1: "Manu Saale, Managing Director and CEO, Mercedes-Benz Research and Development India",
      p2: "",
    },
    {
      date: "3:10 PM to 3:40 PM",
      topic:
        "Fireside Chat: Sustainable Mobility – Role in Climate Protection & its Impact on Cities",
      p1: "Ola Källenius, Chairman of the Board of Management of Mercedes-Benz Group AG",
      p2: "Manu Saale, Managing Director and CEO, Mercedes-Benz Research and Development, India",
    },
    {
      date: "3:40 PM to 3:50 PM",
      topic:
        "Launch of beVisioneers Global Fellowship Program funded by Mercedes-Benz",
      p1: "Ola Källenius, Chairman of the Board of Management of Mercedes-Benz Group AG",
      p2: "Renata Jungo Brüngger, Board Member, Mercedes-Benz Group AG, Integrity & Legal Affairs",
    },
    {
      date: "3:50 PM to 4:05 PM",
      topic: "Short Break",
      p1: "",
      p2: "",
    },
    {
      date: "4:05 PM to 4:45 PM",
      topic:
        "Panel Discussion 1: Emerging Opportunities of Sustainable Supply Chain Management",
      p1: "Renata Jungo Brüngger, Board Member, Mercedes-Benz Group AG, Integrity & Legal Affairs",
      p2: "Santosh Iyer, Managing Director and CEO, Mercedes-Benz India ",
      p3: "Dr R Balasubramaniam, Development Scholar and Author, Founder – SVYM and GRAAM",
      p4: "Kopal Agrawal, Chief Procurement Officer, Hindalco Industries Limited",
      p5: "Rathish Balakrishnan, Co-Founder, Sattva Consulting(Moderator)",
    },
    {
      date: "4:45 PM to 5:25 PM",
      topic:
        "Panel Discussion 2: Traffic Safety – Leveraging Data and Technology for Sustainable Change",
      p1: "Markus Schäfer , Board Member, Mercedes- Benz Group AG, CTO, Development and Procurement",
      p2: "Jochen Feese, Head of Accident Research, Child Safety, Concepts, Sensor Functions and Systems, Mercedes- Benz Group AG",
      p3: "Pramad Jandhyala, Co-Founder and Director – LatentView",
      p4: "Geetam Tewari, Core Faculty – Transport Research and Injury Prevention Centre – IIT Delhi",
      p5: "Sanjay Jain – Partner at Bharat Innovation Fund, Chief Innovation Officer at CIIE.co (Moderator)",
    },
    {
      date: "5:25 PM to 5:30 PM",
      topic: "Summary and Closure (Online participants)",
      p1: "Shweta Pandey, Vice President, Legal & Compliance, Mercedes-Benz Research and Development India",
    },
  ],
  event_agenda: [
    {
      date: "3:00 PM to 3:10 PM",
      topic1: "Welcome Note",
      p1: "Manu Saale, Managing Director and CEO, Mercedes-Benz Research and Development India",
      p2: "",
    },
    {
      date: "3:10 PM to 3:40 PM",
      topic1:
        "Fireside Chat: Sustainable Mobility – Role in Climate Protection & its Impact on Cities",
      p1: "Ola Källenius, Chairman of the Board of Management of Mercedes-Benz Group AG",
      p2: "Manu Saale, Managing Director and CEO, Mercedes-Benz Research and Development, India",
    },
    {
      date: "3:40 PM to 3:50 PM",
      topic1:
        "Launch of beVisioneers Global Fellowship Program funded by Mercedes-Benz",
      p1: "Ola Källenius, Chairman of the Board of Management of Mercedes-Benz Group AG",
      p2: "Renata Jungo Brüngger, Board Member, Mercedes-Benz Group AG, Integrity & Legal Affairs",
    },
    {
      date: "3:50 PM to 4:05 PM",
      topic1: "Short Break",
      p1: "",
      p2: "",
    },
    {
      date: "4:05 PM to 4:45 PM",
      topic1:
        "Panel Discussion 1: Emerging Opportunities of Sustainable Supply Chain Management",
      p1: "Renata Jungo Brüngger, Board Member, Mercedes-Benz Group AG, Integrity & Legal Affairs",
      p2: "Santosh Iyer, Managing Director and CEO, Mercedes-Benz India ",
      p3: "Dr R Balasubramaniam, Development Scholar and Author, Founder – SVYM and GRAAM",
      p4: "Kopal Agrawal, Chief Procurement Officer, Hindalco Industries Limited",
      p5: "Rathish Balakrishnan, Co-Founder, Sattva Consulting(Moderator)",
    },
    {
      date: "4:45 PM to 5:25 PM",
      topic1:
        "Panel Discussion 2: Traffic Safety – Leveraging Data and Technology for Sustainable Change",
      p1: "Markus Schäfer , Board Member, Mercedes- Benz Group AG, CTO, Development and Procurement",
      p2: "Jochen Feese, Head of Accident Research, Child Safety, Concepts, Sensor Functions and Systems, Mercedes- Benz Group AG",
      p3: "Pramad Jandhyala, Co-Founder and Director – LatentView",
      p4: "Geetam Tewari, Core Faculty – Transport Research and Injury Prevention Centre – IIT Delhi",
      p5: "Sanjay Jain – Partner at Bharat Innovation Fund, Chief Innovation Officer at CIIE.co (Moderator)",
    },
    {
      date: "5:25 PM to 5:30 PM",
      topic1: "Summary and Closure (Online participants)",
      p1: "Shweta Pandey, Vice President, Legal & Compliance, Mercedes-Benz Research and Development India",
    },
    {
      date: "5:30 PM to 6:25 PM",
      topic1: "1. Partnerships – For Green & Safe Sustainable Transition",
      topic2: "2. People – CSR & Social Impact",
      topic3:
        "3. Integrity – Conscious Decisions- Foundation for Sustainable Product & Service development",
      p1: "Moderator – Prasanna Gonuguntala, Sr. Vice President & Head, RD, Mercedes-Benz Research and Development India",
      p2: "Moderator – Shweta Pandey, Vice President, Legal & Compliance, Mercedes-Benz Research and Development India",
      p3: "Moderator – Mahesh Medhekar, Vice President, Human Resources, Mercedes-Benz Research and Development India",
    },
    {
      date: "6:25 PM to 6:30 PM",
      topic1: "Summary of the Event",
      p1: "Shweta Pandey, Vice President, Legal & Compliance, Mercedes-Benz Research and Development India",
    },
    {
      date: "6:30 PM to 7:00 PM",
      topic1: "Concert – Sarangi – Rendition",
      p1: "",
    },
    {
      date: "7:00 PM to 7:05 PM",
      topic1: "Summary of the Event",
      p1: "Shweta Pandey, Vice President, Legal & Compliance, Mercedes-Benz Research and Development India",
    },
  ],

  speakers: [
    {
      name1: "Ola Källenius",
      name2: "Geetam Tewari",
      designation1:
        "Chairman of the Board of Management, Mercedes-Benz Group AG",
      designation2: "Professor of Transport Planning, IIT Delhi",
      image1: "icon-1.png",
      image2: "icon-2.jpeg",
    },
    {
      name1: "Renata Jungo Brüngger",
      designation1:
        "Member of the Board of Management, Integrity & Legal Affairs, Mercedes-Benz Group AG",
      image1: "icon-3.png",
      name2: "Kopal Agarwal",
      designation2: "Chief Procurement Officer, Hindalco Industries",
      image2: "icon-4.jpeg",
    },
    {
      name1: "Markus Schäfer",
      designation1:
        "Member of the Board of Management, Chief Technology Officer, Development & Procurement, Mercedes-Benz Group AG",
      image1: "icon-5.png",
      name2: "Prachi Shevgaonkar",
      designation2: "Climate Entrepreneur and the founder of Cool The Globe",
      image2: "icon-6.png",
    },
    {
      name1: "Manu Saale",
      designation1:
        "Managing Director and CEO, Mercedes-Benz Research and Development India",
      image1: "icon-7.png",
      name2: "Pramad Jandhyala",
      designation2: "Co-Founder, LatentView",
      image2: "icon-8.jpeg",
    },
    {
      name1: "Santosh Iyer",
      designation1: "Managing Director and CEO, Mercedes-Benz India",
      image1: "icon-9.png",
      name2: "Dr R Balasubramaniam",
      designation2:
        "Founder – Swami Vivekanand Youth Movement and Grassroots Research and Advocacy Movement Sattva Consulting",
      image2: "icon-10.jpeg",
    },
    {
      name1: "Jochen FEESE",
      designation1:
        "Head of Accident Research, Concepts, Child Safety, Sensor Functions & Systems of Integral Safety. Mercedes-Benz AG",
      image1: "icon-11.jpeg",
      name2: "Rathish Balakrishnan",
      designation2: "Co-Founder and Managing Partner, Sattva Consulting",
      image2: "icon-12.jpeg",
    },
    {
      name1: "Sanjay Jain",
      designation1:
        "Partner, Bharat Innovation Fund and Chief Innovation Officer at CIIE",
      image1: "icon-13.png",
      name2: "",
      designation2: "",
      image2: "",
    },
  ],
  speakers_info: {
    "Ola Källenius": {
      name: "Ola Källenius",
      designation:
        "Chairman of the Board of Management, Mercedes-Benz Group AG",
      details1: "",
      image: "icon-1.png",
      url: "https://www.linkedin.com/in/ola-k%C3%A4llenius/",
    },
    "Geetam Tewari": {
      name: "Geetam Tewari",
      designation: "Professor of Transport Planning, IIT Delhi",
      details1:
        "Geetam comes with 25+ years of professional experience in the areas of Transport Planning, and Traffic Engineering in India, USA, Bangladesh and African Countries. Teacher of transport planning and modelling, traffic engineering, geometric design of highways and Transport Economics at graduate and undergraduate level at the Indian Institute of Technology in Delhi since 1990. Member of Transportation Research and Injury Prevention Programme at IIT Delhi. Extensive research experience in dealing with transportation issues of special relevance to low-income countries. ",
      image: "icon-2.jpeg",
      url: "https://in.linkedin.com/in/geetam-tiwari-669974a",
    },
    "Renata Jungo Brüngger": {
      name: "Renata Jungo Brüngger",
      designation:
        "Member of the Board of Management of Mercedes-Benz Group AG, Integrity, Governance & Sustainability",
      details1:
        "Renata Jungo Brüngger has been a member of the Board of Management of Daimler AG – now Mercedes-Benz Group AG - since January 1, 2016, with responsibility for Integrity, Governance and Sustainability. She is also a member of the Board of Management of Mercedes-Benz AG.",
      details2:
        "Renata Jungo Brüngger was born on August 7, 1961, in Fribourg, Switzerland. After completing her bilingual studies of jurisprudence at the University of Fribourg in Switzerland in 1985, she became a licensed attorney-at-law in 1989. While working as a lawyer, she attended an additional course of studies at the University of Zurich and gained a Master of Laws (LL.M.) in international commercial law, specialising in intellectual property rights and technology and information rights, in 1998. She joined the former Daimler AG as Head of Legal in 2011.",
      details3:
        "This Board of Management position includes Mercedes-Benz Group’s Legal Department, the Compliance Organisation and the Legal Product & Technology as well as the Corporate Data Protection and Corporate Audit. It is also responsible for respecting and protecting human rights and for the sustained anchoring of a corporate culture of integrity (Integrity & Sustainability Management) throughout the Group.",
      image: "icon-3.png",
      image1: "renata.png",
      url: "https://www.linkedin.com/in/renata-jungobruengger/",
    },
    "Kopal Agarwal": {
      name: "Kopal Agarwal",
      designation: "Chief Procurement Officer, Hindalco Industries",
      details1:
        "Kopal Agarwal works as the Chief Procurement Officer for Hindalco Industries Limited where she heads the raw material and procurement department. She has an in-depth understanding of commodity market contracts, sales and purchase contracts, legal frameworks, tendering processes, pricing dependencies and market movements in the supply chain. Prior to joining Hindalco in 2018, Kopal worked with Schlumberger– one of the world’s most reputed offshore drilling companies – for a decade. She comes with 20+ years of experience managing and leading 200+ member teams.",
      image: "icon-4.jpeg",
      url: "https://www.linkedin.com/in/kopal-agrawal-739189a/",
    },
    "Markus Schäfer": {
      name: "Markus Schäfer",
      designation:
        "Member of the Board of Management, Chief Technology Officer, Development & Procurement, Mercedes-Benz Group AG",
      details1: "",
      image: "icon-5.png",
      url: "https://www.linkedin.com/in/markus-sch%C3%A4fer/",
    },
    "Prachi Shevgaonkar": {
      name: "Prachi Shevgaonkar",
      designation: "Climate Entrepreneur and the founder of Cool The Globe",
      details1:
        "Prachi Shevgaonkar is a Climate Entrepreneur and the founder of Cool The Globe - An app for climate action with users from 100+ countries. Prachi has been awarded by the finance minister of India as the 'Young Change-maker of the year.'",
      details2:
        "Prachi is the first Indian citizen to be appointed on the advisory board of Climate Leadership Coalition, alongside the former Prime Minister of Finland. She was selected by the Ministry of Environment and UNICEF to represent India at COP27 climate summit in Egypt, where she received COP27 Young Scholar Award from the Hon. Environment Minister Bhupender Yadav. Recently, Prachi featured in Google India's campaign inspired by her story of building Cool The Globe App.",
      image: "icon-6.png",
      url: "https://www.linkedin.com/in/prachi-shevgaonkar-b8145714a/",
    },
    "Manu Saale": {
      name: "Manu Saale",
      designation: "MD & CEO, Mercedes-Benz Research and Development India",
      details1:
        "As the Managing Director and CEO of Mercedes-Benz Research and Development India (MBRDI), Manu leads the largest research and development centre for Mercedes-Benz Group AG outside of Germany. Manu holds close to three decades of experience in the automobile innovation and engineering sector. He has served across various leadership positions and played an instrumental role in achieving organisational transformation by effectively navigating complex business challenges.",
      details2:
        "With a special focus on digital engineering, ensuring the safety of passengers and road users, Manu leads an extensive team of 8500+ talented engineers, who play a key role in accelerating the future of smart and sustainable mobility and delivering world-class solutions across global projects. MBRDI’s role on the global stage has transformed significantly during his tenure as CEO – from being preferred merely for cost arbitrage to being recognised as a strategic partner for the group with its skilled workforce, exceptional value creation, and impactful innovations at scale.",
      image: "icon-7.png",
      image1: "manu.png",
      url: "https://in.linkedin.com/in/manu-saale-9487563",
    },
    "Pramad Jandhyala": {
      name: "Pramad Jandhyala",
      designation: "Co-Founder, LatentView",
      details1:
        "Co-Founder of an analytics company providing customers with actionable insights from digital data, which helps create brands, products and services that engage with consumers, across touch points. Helped build LatentView from ground up anchoring key roles in strategy and execution to guide Latent View's rapid growth and recognition. Prior to founding Latent View, Pramad held positions with IBM, Ford, Moody’s ICRA and Kotak Mahindra Bank.",
      image: "icon-8.jpeg",
      url: "https://www.linkedin.com/in/pramad/",
    },
    "Santosh Iyer": {
      name: "Santosh Iyer",
      designation: "MD & CEO, Mercedes-Benz India Limited",
      details1:
        "Santosh Iyer is the Managing Director & CEO, Mercedes-Benz India. He has been associated with Mercedes-Benz since 2009 in various leadership roles. At Mercedes-Benz, Santosh directs the company’s India market strategy, curating future growth roadmap, strategising market expansion, and building strong foundation for a future-ready, vibrant, and diverse organisation.",
      details2:
        "Prior to his appointment as the MD & CEO, Santosh was the Vice President, Sales & Marketing of the company. He successfully led the company’s digital transformation, establishing online sales and steering it to sustainable growth during the pandemic. Santosh was pivotal in conceptualising and implementing ‘Retail of the Future’ business model, with India as one of the first markets within Mercedes-Benz AG, to have successfully implemented this model in 2021. Santosh’s earlier stint in the company had been with Customer Services, Corporate Afairs & CSR functions, where he drove ‘service differentiation’ as the key parameter for achieving service excellence and customer loyalty.",
      image: "icon-9.png",
      image1: "santosh.png",
      url: "https://www.linkedin.com/in/santosh-iyer-68322070/",
    },
    "Dr R Balasubramaniam": {
      name: "Dr R Balasubramaniam",
      designation:
        "Founder – Swami Vivekanand Youth Movement and Grassroots Research and Advocacy Movement Sattva Consulting",
      details1:
        "Dr Ramaswami Balasubramaniam is a development scholar, author, public policy advocate and leadership trainer known for his pioneering development work for over 2 decades with rural and tribal people. He is currently a full time Member-HR in the Capacity Building Commission of the Government of India. He also serves as a technical member of the Social Stock Exchange (SSE) constituted by the SEBI. He is the Founder of Grassroots Research And Advocacy Movement (GRAAM), a public policy think tank as well as the Swami Vivekananda Youth Movement (SVYM), a development organization, both based out of Mysuru. He was the Frank H T Rhodes Professor at Cornell University between 2012 to 2014, and continues to hold academic positions in Cornell and other universities.",
      image: "icon-10.jpeg",
      url: "https://www.linkedin.com/in/r-balasubramaniam/",
    },
    "Jochen FEESE": {
      name: "Jochen FEESE",
      designation: "Head of Accident Research, Vehicle Safety! ",
      details1:
        "In 1991, Jochen Feese joined the Mercedes-Benz AG. 1994, he received his diploma in electrical engineering at the Cooperative State University in Stuttgart and began his career in the Mercedes-Benz passenger car development. Until October 2000, he worked in the cockpit development.",
      details2:
        "He then moved to the Group Research & Advanced Engineering division and worked as executive assistant for the research directorates Electronics and Mechatronics and Corporate Quality Management.",
      image: "icon-11.jpeg",
      url: "https://www.linkedin.com/in/jochen-feese-a09a20a4/",
    },
    "Rathish Balakrishnan": {
      name: "Rathish Balakrishnan",
      designation: "Co-Founder and Managing Partner, Sattva Consulting",
      details1:
        "Rathish Balakrishnan comes with 20+ years of experience across the corporate and social sector. As Partner and Managing Partner at Sattva, he brings his extensive experience in conceptualising and implementing large-scale solutions that brings together leading foundations, corporations, civil society organisations and the government. Prior to founding Sattva Consulting, he worked at SAP Labs. His last role at the technology company involved driving cross product management initiatives across SAP Middleware Technology Platform.",
      image: "icon-12.jpeg",
      url: "https://www.linkedin.com/in/rathishbalakrishnan/",
    },
    "Sanjay Jain": {
      name: "Sanjay Jain",
      designation:
        "Partner, Bharat Innovation Fund and Chief Innovation Officer at CIIE",
      details1:
        "Sanjay is a Partner at the Bharat Innovation Fund, at IIM Ahmedabad and the Chief Innovation Officer at CIIE, where he leads efforts to help create, promote, and encourage entrepreneurship in areas around digital technology. He is also the founding chair of the technology committee, for the Modular Open-Source Identity Platform - MOSIP - that helps user organizations such as Governments implement a digital, foundational ID in a cost-effective way, while embracing the best practices of scalability, security and privacy harnessing the power of open source. Besides, he volunteers with iSPIRT, the software product industry think tank and has been one of the key contributors to help create, and evangelize various government APIs, which are collectively referred to as the India Stack. ",
      image: "icon-13.png",
      url: "https://www.linkedin.com/in/snjyjn/",
    },
  },
};

//Sustainability Event 2024

const SUSTAINABILITY_24 = {
  title_desc: {
    p1: "As Mercedes-Benz, we want to shape the future and make it as sustainable as possible.",
    p2: "We believe that sustainability means creating permanent value for all stakeholder groups—customers, employees, investors, partners, and society as a whole. In line with this, our economic, environmental, and social responsibility entails ensuring that the entire value chain is brought along on this journey towards sustainability.",
    p3: "Come join us on 3 September 2024, for the second edition of Sustainability Dialogue – India as we foster discussion and collaboration on responsible usage of our planetary resources and accelerate our collective transition to carbon neutrality.",
  },
  agenda: [
    {
      date: "10:00 AM",
      session: "Introduction",
    },
    {
      date: "10:10 AM",
      session:
        "Leaders’ Insights: Global Sustainability Trends and their Impact on the Indian Automotive Industry",
    },
    {
      date: "11:05 AM",
      p1: "",
      session:
        "Panel Discussion: Traffic Safety – Current Perspectives and Future Trends for Safe Roads in India",
    },
    {
      date: "12:00 PM",
      session:
        "Panel Discussion: Digital Trust – Artificial Intelligence and Data Responsibility",
    },
    {
      date: "12:45 PM",
      session: "Summary",
    },
  ],
  speakers: [
    {
      name1: "Amitabh Kant",
      designation1: "India's G20 Sherpa, and former CEO, NITI Aayog",
      image1: "amitab.png",
      name2: "Renata Jungo Brüngger",
      designation2:
        "Member of the Board of Management of Mercedes-Benz Group AG, Integrity, Governance & Sustainability",
      image2: "renata.png",
    },
    {
      name1: "Manu Saale",
      designation1: "MD & CEO, Mercedes-Benz Research and Development India",
      image1: "manu.png",
      name2: "Shweta Pandey",
      designation2:
        "VP, Legal & Compliance, Mercedes-Benz Research and Development India",
      image2: "shweta.png",
    },
    {
      name1: "Christoph Von Hugo",
      designation1:
        "Head of Driver Assistance, Automated Driving & Active Safety, Mercedes-Benz AG",
      image1: "christop.png",
      name2: "Santosh Iyer",
      designation2: "MD & CEO, Mercedes-Benz India Limited",
      image2: "santosh.png",
    },
    {
      name1: "Amir Bazaz",
      designation1:
        "Associate Dean, Head - Climate and Infrastructure, Indian Institute of Human Settlements",
      image1: "amir.png",
      name2: "Sonal Shah",
      designation2:
        "Executive Director, Centre for Sustainable and Equitable Cities",
      image2: "sonal.png",
    },
    {
      name1: "Srikrishna Sridhar Murthy",
      designation1: "Co-founder and CEO, Sattva Consulting",
      image1: "krishna.png",
      name2: "Umang Dharmik",
      designation2:
        "Senior Vice President, Mercedes-Benz Research and Development India",
      image2: "umang.png",
    },
    {
      name1: "Alok B. Lall",
      designation1:
        "Chief Operating Officer - India and South Asia, Microsoft Corporation",
      image1: "alok.png",
      name2: "Vinayak Godse",
      designation2: "CEO, Data Security Council of India",
      image2: "vinayak.png",
    },
    {
      name1: "Ajeya Motaganahalli",
      designation1:
        "Vice President, Engineering and Managing Director, R&D, India, Pure Storage",
      image1: "ajeya.png",
      name2: "",
    },
  ],
  speakers_info: {
    "Ajeya Motaganahalli": {
      name: "Ajeya Motaganahalli",
      designation:
        "Vice President, Engineering and Managing Director, R&D, India, Pure Storage",
      details1:
        "Ajeya Motaganahalli is Vice President, Engineering, FlashBlade and Managing Director, India R&D at Pure Storage. In this role, Ajeya leads the FlashBlade engineering teams across the globe in addition to leading the company’s R&D capabilities in India.",
      details2:
        "Ajeya is a well-regarded leader in the Indian engineering community with deep expertise in enterprise storage and has served in leadership roles at several other multinational technology companies. Previously, Ajeya has held technology and leadership positions at Honeywell, NetApp, and EMC. Passionate about deep tech, building scalable products, and startups, Ajeya set up a global accelerator program for startups earlier in his career.",
      image: "ajeya.png",
      url: "https://www.linkedin.com/in/ajeyamotaganahalli/",
    },
    "Manu Saale": {
      name: "Manu Saale",
      designation: "MD & CEO, Mercedes-Benz Research and Development India",
      details1:
        "As the Managing Director and CEO of Mercedes-Benz Research and Development India (MBRDI), Manu leads the largest research and development centre for Mercedes-Benz Group AG outside of Germany. Manu holds close to three decades of experience in the automobile innovation and engineering sector. He has served across various leadership positions and played an instrumental role in achieving organisational transformation by effectively navigating complex business challenges.",
      details2:
        "With a special focus on digital engineering, ensuring the safety of passengers and road users, Manu leads an extensive team of 8500+ talented engineers, who play a key role in accelerating the future of smart and sustainable mobility and delivering world-class solutions across global projects. MBRDI’s role on the global stage has transformed significantly during his tenure as CEO – from being preferred merely for cost arbitrage to being recognised as a strategic partner for the group with its skilled workforce, exceptional value creation, and impactful innovations at scale.",
      image: "manu.png",
      url: "https://in.linkedin.com/in/manu-saale-9487563",
    },
    "Renata Jungo Brüngger": {
      name: "Renata Jungo Brüngger",
      designation:
        "Member of the Board of Management of Mercedes-Benz Group AG, Integrity, Governance & Sustainability",
      details1:
        "Renata Jungo Brüngger has been a member of the Board of Management of Daimler AG – now Mercedes-Benz Group AG - since January 1, 2016, with responsibility for Integrity, Governance and Sustainability. She is also a member of the Board of Management of Mercedes-Benz AG.",
      details2:
        "Renata Jungo Brüngger was born on August 7, 1961, in Fribourg, Switzerland. After completing her bilingual studies of jurisprudence at the University of Fribourg in Switzerland in 1985, she became a licensed attorney-at-law in 1989. While working as a lawyer, she attended an additional course of studies at the University of Zurich and gained a Master of Laws (LL.M.) in international commercial law, specialising in intellectual property rights and technology and information rights, in 1998. She joined the former Daimler AG as Head of Legal in 2011.",
      details3:
        "This Board of Management position includes Mercedes-Benz Group’s Legal Department, the Compliance Organisation and the Legal Product & Technology as well as the Corporate Data Protection and Corporate Audit. It is also responsible for respecting and protecting human rights and for the sustained anchoring of a corporate culture of integrity (Integrity & Sustainability Management) throughout the Group.",
      image: "renata.png",
      url: "https://www.linkedin.com/in/renata-jungobruengger/",
    },
    "Santosh Iyer": {
      name: "Santosh Iyer",
      designation: "MD & CEO, Mercedes-Benz India Limited",
      details1:
        "Santosh Iyer is the Managing Director & CEO, Mercedes-Benz India. He has been associated with Mercedes-Benz since 2009 in various leadership roles. At Mercedes-Benz, Santosh directs the company’s India market strategy, curating future growth roadmap, strategising market expansion, and building strong foundation for a future-ready, vibrant, and diverse organisation.",
      details2:
        "Prior to his appointment as the MD & CEO, Santosh was the Vice President, Sales & Marketing of the company. He successfully led the company’s digital transformation, establishing online sales and steering it to sustainable growth during the pandemic. Santosh was pivotal in conceptualising and implementing ‘Retail of the Future’ business model, with India as one of the first markets within Mercedes-Benz AG, to have successfully implemented this model in 2021. Santosh’s earlier stint in the company had been with Customer Services, Corporate Afairs & CSR functions, where he drove ‘service differentiation’ as the key parameter for achieving service excellence and customer loyalty.",
      image: "santosh.png",
      url: "https://www.linkedin.com/in/santosh-iyer-68322070/",
    },
    "Alok B. Lall": {
      name: "Alok B. Lall",
      designation:
        "Chief Operating Officer - India and South Asia, Microsoft Corporation",
      details1:
        "As the COO for Microsoft India and South Asia, Alok leads the strategy, marketing and operations for the region. He is part of the senior leadership team and drives the region's long-term growth goals for Microsoft to be the most trusted and innovative AI partner in India and South Asia. He leads a team of marketing and operations leaders who work to build awareness with customer stakeholders and improve sales performance within Microsoft and through its partner ecosystem. Alok also works closely with the product engineering teams to bring customer, partner and developer feedback into the innovation process in the region.",
      details2:
        "Alok cares deeply about Accessibility and Sustainability and has spoken for Microsoft in several industry and business forums on these topics. He has over twenty-six years of experience as a technology and business leader, twenty-four at Microsoft India, where he has demonstrated impact across a diversity of business and technical roles.",
      details3:
        "Alok has a B.E. (Honours) in Electronics & Telecom from the National Institute of Technology, Silchar, Assam. He enjoys listening to music and travelling with his wife, Ritu and daughter, Shreya in his spare time.",
      image: "alok.png",
      url: "https://www.linkedin.com/in/alok-lall/",
    },
    "Amir Bazaz": {
      name: "Amir Bazaz",
      designation:
        "Associate Dean, Head - Climate and Infrastructure, Indian Institute of Human Settlements",
      details1:
        "Amir heads Infrastructure and Climate Practice at IIHS. He is also the Associate Dean in IIHS School of Environment and Sustainability and the School of Systems and Infrastructure. With nearly 25 years of professional experience, his expertise spans multiple engineering roles, and as a climate and energy policy researcher and practitioner. Amir holds a PhD in Management from IIM Ahmedabad, specializing in Public Systems, and works on issues intersecting economics, finance, climate change mitigation and adaptation, just energy transitions, and sustainable development.",
      details2:
        "Amir has extensive experience in city governance, market and non-market frameworks, and economy-energy-environment modeling. He has been a National Expert Consultant to India's Ministry of Environment, Forests, and Climate Change and has worked in sub-Saharan Africa, South Asia, Latin America, and Europe. He was the Lead Author on the CDRI Global Infrastructure Resilience 2023 report, Green Climate Fund's 2021 report on scaling up climate finance, and the Summary for Urban Policy Makers 2022. He contributed to the IPCC WG II Assessment Report 6 and the IPCC 2018 Special Report on 1.5°C. Besides research, Amir teaches Infrastructure Systems and Development Economics at the postgraduate level and has mentored nearly 50 young researchers.",
      image: "amir.png",
      url: "https://www.linkedin.com/in/amir-bazaz-6916588/",
    },
    "Amitabh Kant": {
      name: "Amitabh Kant",
      designation: "India's G20 Sherpa, and former CEO, NITI Aayog",
      details1:
        "Amitabh Kant is presently India’s G20 Sherpa. The G20 or the Group of Twenty is a forum where policymakers of industrialised and developing economies meet to discuss key issues in the global economy.",
      details2:
        "Amitabh Kant is a governance reformer and a public policy change agent for India, having driven key reforms and initiatives during his tenure as the Chief Executive Officer of the National Institution for Transforming India (NITI Aayog) (2016-2022) and the Secretary of the Department for Industrial Policy and Promotion (DIPP) (2014-2016), Government of India. He has been a key driver of flagship national initiatives such as Startup India, Make in India, Incredible India, Kerala: God’s Own Country and the Aspirational Districts Program. These initiatives have repositioned India and Kerala and have widely been recognised as transformational.",
      image: "amitab.png",
      url: "https://www.linkedin.com/in/amitabh-kant-3680b01b1/",
    },
    "Srikrishna Sridhar Murthy": {
      name: "Srikrishna Sridhar Murthy",
      designation: "Co-founder and CEO, Sattva Consulting",
      details1:
        "Srikrishna Sridhar Murthy brings over a decade of work experience working with the leadership team of global foundations, social organisations and corporates to design and scale their social impact initiatives, across India, SE Asia, Africa and Europe. He is passionate about solving global social problems using economics, institutions and ecosystems as key tools.",
      details2:
        "As the CEO at Sattva, he is responsible for the overall strategic direction, growth and impact of the organisation. Srikrishna leads several collective impact initiatives across different themes like water, education and livelihoods.",
      details3:
        "Before founding Sattva, Srikrishna was the Founding Partner of Longhouse Consulting, a boutique executive search firm focused on technology and emerging sectors in India. He started his career as an early member of Dell R&D in India. Currently, he  serves on the Advisory Board of multiple social impact and technology start-ups as well.",
      image: "krishna.png",
      url: "https://www.linkedin.com/in/srikrishnas/",
    },
    "Umang Dharmik": {
      name: "Umang Dharmik",
      designation:
        "Senior Vice President, Mercedes-Benz Research and Development India",
      details1:
        "Umang brings over 18 years of experience from diverse locations including Australia, Singapore, Stuttgart, and India. Throughout his career, Umang has been deeply involved in driving digital transformation initiatives, leveraging his expertise to implement innovative solutions and streamline operations. At MBRDI, Umang continues to make a significant impact, leading a team of passionate professionals who share his ‘can-do’ attitude and commitment to achieving excellence.",
      image: "umang.png",
      url: "https://www.linkedin.com/in/umangdharmik/",
    },
    "Vinayak Godse": {
      name: "Vinayak Godse",
      designation: "CEO, Data Security Council of India",
      details1:
        "Vinayak Godse is the CEO of Data Security Council of India. He has been associated with DSCI since its inception in 2008. He has over 27 years of experience in Information Security, IT Transformation, Intelligent Networking and Telecom Infrastructure. Vinayak also leads the National Centre of Excellence (NCoE) for Cybersecurity Technology and Entrepreneurship, a joint initiative of DSCI and Ministry of Electronics & IT.",
      details2:
        "He is engaged in the DSCI outreach program at national and international platforms in establishing collaboration with different legal and regulatory bodies, data protection authorities, global clients, and service providers. He is the principal author of the DSCI Security Framework (DSF) and DSCI Privacy Framework (DPF). He was instrumental in developing privacy credential program, DSCI Certified Privacy Lead Assessor (DCPLA) and DSCI Certified Privacy Professional [DCPP].",
      details3:
        "He is also closely working with government bodies involved in policymaking and capability building in national cybersecurity, data protection, and data policies. Vinayak contributes to national and sectoral initiatives, including empanelment auditors by CERT-In, RBI sub-committees on cybersecurity and SEBI’s High Powered Steering Committee on Cyber Security (HPSC-CS).",
      image: "vinayak.png",
      url: "https://www.linkedin.com/in/vinayakgodse/",
    },
    "Christoph Von Hugo": {
      name: "Christoph Von Hugo",
      designation:
        "Head of Driver Assistance, Automated Driving & Active Safety, Mercedes-Benz AG",
      details1: "",
      image: "christop.png",
      url: "https://www.linkedin.com/in/christoph-von-hugo-11796190/",
    },
    "Sonal Shah": {
      name: "Sonal Shah",
      designation:
        "Executive Director, Centre for Sustainable and Equitable Cities",
      details1:
        "Sonal Shah is the Executive Director of the Centre for Sustainable and Equitable Cities and the founder of The Urban Catalysts, advising multiple stakeholders – governments, development banks, philanthropic organisations, and think tanks on sustainable, equitable city planning, and transport.",
      details2:
        "Over the last 15 years, Sonal has worked across 10 states in India, as well as Asia, the Middle East, and the United States focusing on sustainable urban transport, non-motorised transport, integrated public transport, land-use and transport integration, and gender equity. Sonal was responsible for introducing India’s first gender-sensitive urban planning guidelines and actively contributed towards revising India’s national urban street design guidelines (IRC codes) to make them people-oriented.",
      details3:
        "Sonal has led projects supported by the World Bank, AfD, UK Aid, ADB, IKI, Oak Foundation, Gates Foundation, GIZ, and Bloomberg Philanthropies. She has taught at numerous institutions such as the Indian Institute for Human Settlements, Anant National University, KRVIA, Academy of Architecture, and the JJ School of Architecture.",
      image: "sonal.png",
      url: "https://www.linkedin.com/in/sshah7/",
    },
    "Shombi Sharp": {
      name: "Shombi Sharp",
      designation: "India's G20 Sherpa, and former CEO, NITI Aayog",
      details1: "",
      image: "shombi.png",
      url: "",
    },
    "Shweta Pandey": {
      name: "Shweta Pandey",
      designation:
        "VP, Legal & Compliance, Mercedes-Benz Research and Development India",
      details1:
        "Shweta provides strategic legal guidance to MBRDI’s Board of Directors and Executive Leadership, leading the Legal, Compliance, Corporate Affairs, Corporate Social Responsibility, and Sustainability functions. As a member of the Executive Leadership and the POSH Committee, she ensures comprehensive legal support across the company.",
      details2:
        "A gold medalist from Nalsar University of Law, Hyderabad, Shweta has held roles at Cyril Amarchand Mangaldas, IBM India, Infosys US, and Target Corporation India, where she was the youngest Board Member. She has received several awards, including the ‘Leading Women in Business Award 2023’ from the World Business Council for Sustainability Development.",
      details3:
        "Passionate about gender equality, Shweta’s early experiences at the National Commission for Women inspired her to pursue law and advocate for women’s rights. She has authored papers on domestic violence and provided pro bono legal assistance to women's rights NGOs in India. Outside of work, Shweta enjoys theatre and the sport of professional shooting.",
      image: "shweta.png",
      url: "https://www.linkedin.com/in/shwetapandey83/",
    },
  },
};

const SUPPORT_INFO = {
  title1:
    "In case you experience any technical difficulties or have other queries, please reach out to us at:",
  title2:
    "Some quick to-dos if you are facing issues during your virtual participation:",
  p1: "Close the tab and open the link again.",
  p2: "Try a different browser and/or check if the browser needs to be updated",
  p3: "Check that the sound on your device is turned on and loud enough.",
  p4: "Make sure your headset is set or plugged in correctly, or try testing without a headset.",
  p5: "Close all other applications on your device.",
  p6: "If you are connected via VPN, please disable the connection.",
  p7: "If available, try to participate via your smartphone or other device.",
};

const SUSTAINABILITY_25 = {
  title_desc: {
    p1: "Sustainability is at the foundation of meaningful progress and lasting transformation. At Mercedes-Benz,this belief drives our commitment to comprehensive economic, environmental, and social responsibility across the entire value chain. ",
    p2: "On 3 september 2025, the third edition of Mercedes-Benz Sustainability Dialogue India will facilitate impactful discussions and build strategic collaborations that drive responsible resource management and accelerate our shared transition to carbon neutrality. This year's Dialogue brings together diverse perspective from policy-makers, Industry leaders,civil society, and academia to advance sustainable mobility solutions that support global climate action goals.",
  },
  agenda: [
    {
      date: "4:30 PM",
      session: "Introduction",
    },
    {
      date: "4:40 PM",
      session:
        "Leadership Insights: Global Sustainability Trends and Their Impact on the Indian Automotive Industry",
    },
    {
      date: "5:20 PM",
      p1: "",
      session:
        "Panel Discussion: Decarbonisation and Circularity Opportunities in India",
    },
    {
      date: "6:15 PM",
      session:
        "Panel Discussion: Human and Labour Rights-Centric Governance Systems – Emerging Global Trends and Their Context in India",
    },
    {
      date: "7:00 PM",
      session: "Summary",
    },
  ],
};

export {
  SUSTAINABILITY_23,
  SUSTAINABILITY_24,
  SUSTAINABILITY_25,
  SUPPORT_INFO,
};
